import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  HStack,
  Text
} from '@chakra-ui/react'
import {
  DialogBody,
  DialogContainer,
  DialogHeader
} from '@handlers/sessions/components/dialog'
import Warning from '@material-ui/icons/Warning'
import React from 'react'

interface DeleteTemplateDialogProps {
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
  isDeleting?: boolean
}

export const DeleteTemplateDialog = ({
  isOpen,
  onClose,
  onDelete,
  isDeleting
}: DeleteTemplateDialogProps) => {
  return (
    <DialogContainer isOpen={isOpen} onClose={onClose}>
      <DialogHeader
        textAlign="left"
        text="Delete template?"
        onClose={onClose}
        hideBorder
        pb="0px"
      />
      <DialogBody>
        <Flex direction="column" gap="16px">
          <Text>Are you sure you want to delete this template?</Text>

          <Alert
            status="warning"
            borderRadius="8px"
            bg="rgba(255, 252, 232, 1)"
          >
            <Warning style={{ color: '#F8D557' }} />
            <Text ml="8px">
              <strong>Warning:</strong> This action cannot be undone.
            </Text>
          </Alert>

          <HStack spacing="0px" gap="8px" justifyContent="flex-end" mt="8px">
            <Button
              m="0px"
              flex="1"
              variant="outline"
              type="button"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              m="0px"
              bg="error"
              flex="1"
              color="white"
              type="button"
              onClick={onDelete}
              isLoading={isDeleting}
            >
              Delete template
            </Button>
          </HStack>
        </Flex>
      </DialogBody>
    </DialogContainer>
  )
}

export default DeleteTemplateDialog
